import { useForm, ValidationError } from "@formspree/react";
import { useEffect, useRef, useState } from "react";

export default function ContactForm() {
  const [state, handleSubmit] = useForm("mdkzoaoa");
  const [showMessage, setShowMessage] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    if (state.succeeded) {
      setShowMessage(true);
      if (formRef.current) {
        formRef.current.reset();
      }
    }
  }, [state.succeeded]);

  return (
    <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
      <div className="form-group">
        <input type="text" name="your_name" placeholder="Name*" required />
      </div>
      <div className="form-group">
        <input type="email" name="your_email" placeholder="Email*" required />
        <ValidationError field="email" prefix="Email" errors={state.errors} />
      </div>
      <div className="form-group">
        <input type="tel" name="your_phone" placeholder="Telephone*" required />
      </div>
      <div className="form-group">
        <input
          type="text"
          name="businnes_name"
          placeholder="Business Name"
          required
        />
      </div>
      <div className="form-group">
        <textarea
          name="your_message"
          placeholder="Tell us what’s on your mind*"
          required
        />
        <ValidationError
          field="message"
          prefix="Message"
          errors={state.errors}
        />
      </div>
      <h4>Where do you need momentum?</h4>
      <div className="form-group checkbox-group">
        <label>
          <input type="checkbox" name="strategy_positioning" />
          <span>Strategy & Positioning</span>
        </label>
        <label>
          <input type="checkbox" name="brand_identity_presence" />
          <span>Brand Identity & Presence</span>
        </label>
        <label>
          <input type="checkbox" name="marketing_growth" />
          <span>Marketing & Growth</span>
        </label>
        <label>
          <input type="checkbox" name="something_else" />
          <span>Something Else</span>
        </label>
      </div>

      <button type="submit" disabled={state.submitting}>
        {state.submitting ? "Sending..." : "IGNITE THE SPARK"}
      </button>

      {showMessage && (
        <p
          className="success-message"
          style={{ color: "green", marginTop: "1rem" }}
        >
          Thank you! Your message has been sent.
        </p>
      )}

      {Array.isArray(state.errors) && state.errors.length > 0 && (
        <p
          className="error-message"
          style={{ color: "red", marginTop: "1rem" }}
        >
          There was an error. Please try again.
        </p>
      )}
    </form>
  );
}
